import {Avatar, Box, Group, Menu, Text, UnstyledButton, useMantineColorScheme, useMantineTheme} from "@mantine/core";
import {IconChevronLeft, IconChevronRight, IconLogout} from '@tabler/icons-react';
import {useMsal} from "@azure/msal-react";

interface NavBarUserProfileProps {

}

function NavBarUserProfile() {

    const theme = useMantineTheme();
    const { colorScheme } = useMantineColorScheme();
    const { instance, accounts, inProgress } = useMsal();

    const handleLogout = (logoutType:string) => {
        if ((logoutType) === 'redirect') {
            instance.logoutRedirect({
                postLogoutRedirectUri: "/"
            })
        }
    }

    const generateIconInitials = (word: string | undefined) => {
        if (word == undefined) {
            return "U"
        }
        let initials = "";
        word.split(" ").forEach(w => {
            if (/[a-zA-Z]/i.test(w.charAt(0))) {
                initials += w.charAt(0)
            }
        })
        return initials
    }

    return (
        <Box
            style={{
                paddingTop: theme.spacing.sm,
                paddingBottom: theme.spacing.sm,
                borderTop: `2px solid ${
                    colorScheme === 'dark' ? theme.colors.green[2] : theme.colors.green[2]
                }`,
            }}
        >

            <Menu position='top'>
                <Menu.Target>
                    <UnstyledButton
                        style={{
                            display: 'block',
                            width: '100%',
                            padding: theme.spacing.xs,
                            '&:hover': {
                                backgroundColor: theme.colors.gray[1],
                            },
                        }}
                    >
                        <Group wrap={"nowrap"}>
                            <Avatar color="cyan" radius="xl" style={{border: `1px solid ${theme.colors.green[2]}`}}>
                                {generateIconInitials(accounts[0]?.name)}
                            </Avatar>
                            <Box style={{ flex: 1, overflow: 'hidden' }}>
                                <Text size="sm" fw={500} style={{textOverflow: 'ellipsis', overflow: 'hidden'}} c={theme.colors.textBlack[4]}>
                                    {accounts[0]?.name}
                                </Text>
                                <Text size="xs" style={{textOverflow: 'ellipsis', overflow: 'hidden'}} c={theme.colors.textBlack[4]}>
                                    {accounts[0]?.username}
                                </Text>
                            </Box>
                                <IconChevronRight size={18} color={theme.colors.textBlack[4]}/>
                        </Group>
                    </UnstyledButton>
                </Menu.Target>

                <Menu.Dropdown>
                    <Menu.Item bg={theme.colors.gray[0]} leftSection={<IconLogout />} onClick={() => handleLogout('redirect')}>
                        Log Out
                    </Menu.Item>
                </Menu.Dropdown>
            </Menu>

        </Box>
    )
}

export default NavBarUserProfile